import React from 'react';
import { RadioWrapper, RadioIcon, RadioText } from './components';

const RadioButton = ({ text, selected, onClick }) => (
  <RadioWrapper onClick={onClick}>
    <RadioIcon selected={selected} />
    <RadioText>{text}</RadioText>
  </RadioWrapper>
);

export default RadioButton;
